module.exports = __webpack_public_path__ + "static/media/iPhone14-9.c05cd519.png";